import { render, staticRenderFns } from "./restaurantCategoryTable.vue?vue&type=template&id=2c78b2e1&"
import script from "./restaurantCategoryTable.vue?vue&type=script&lang=js&"
export * from "./restaurantCategoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports